var C = Object.defineProperty, O = Object.defineProperties;
var E = Object.getOwnPropertyDescriptors;
var k = Object.getOwnPropertySymbols;
var x = Object.prototype.hasOwnProperty, I = Object.prototype.propertyIsEnumerable;
var g = (r, n, s) => n in r ? C(r, n, { enumerable: !0, configurable: !0, writable: !0, value: s }) : r[n] = s, c = (r, n) => {
  for (var s in n || (n = {}))
    x.call(n, s) && g(r, s, n[s]);
  if (k)
    for (var s of k(n))
      I.call(n, s) && g(r, s, n[s]);
  return r;
}, m = (r, n) => O(r, E(n));
var w = (r, n, s) => new Promise((p, u) => {
  var l = (e) => {
    try {
      i(s.next(e));
    } catch (a) {
      u(a);
    }
  }, t = (e) => {
    try {
      i(s.throw(e));
    } catch (a) {
      u(a);
    }
  }, i = (e) => e.done ? p(e.value) : Promise.resolve(e.value).then(l, t);
  i((s = s.apply(r, n)).next());
});
import { u as L, a as N } from "./query-client-DZ5Df1It.js";
import { M as T, D as b } from "./constants-S7QMI5p0.js";
import { i as o } from "./utils-CMsllPx8.js";
import { a as v, m as j, r as A } from "./define-element-XpjsV6s1.js";
const _ = v([null, null]), h = v(""), q = v([]);
function Q(r = !1) {
  L();
  const n = b, s = N({
    queryKey: ["product", r],
    staleTime: 1440 * 60 * 1e3,
    // products don't change often — treat persisted data as fresh for a day
    queryFn: () => w(null, null, function* () {
      if (r === !1)
        return [];
      let u = r ? yield A(`cart/categories/${r}/products`) : yield A("cart/products");
      if (u.error)
        return [];
      Array.isArray(u) || (u = Object.values(u));
      const l = {}, t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      return u.forEach((e) => {
        if (o(e.image) && (e.image = "https://s3.amazonaws.com/efcheckout/offsetdemo/products/--Offset-Demo-2021-Offset-Pinot-Noir-product-image-5-large.jpg"), o(e.max_purchase_quantity) && (e.max_purchase_quantity = o(e.purchase_limit) ? T : e.purchase_limit), e.max_purchase_quantity = parseInt(
          e.max_purchase_quantity,
          10
        ), o(e.min_purchase_quantity) && (e.min_purchase_quantity = 1), e.min_purchase_quantity = parseInt(
          e.min_purchase_quantity,
          10
        ), o(e.quantity) && (e.quantity = 1), e.quantity = parseInt(e.quantity, 10), e.quantity !== 0) {
          e.quantity_options = [];
          for (let a = e.min_purchase_quantity; a <= e.max_purchase_quantity; a++)
            e.quantity_options.push(a);
          !o(e.variant_master_sku) && e.variant_master_sku !== e.sku ? t.set(e.variant_master_sku, [
            ...t.get(e.variant_master_sku) || [],
            e
          ]) : i.set(e.sku, e), n.forEach((a) => {
            var y;
            const f = e[a.key];
            f && (l[a.key] = a, l[a.key].options || (l[a.key].options = {}), l[a.key].options[f] = {
              label: f,
              checked: !1,
              count: (((y = l[a.key].options[f]) == null ? void 0 : y.count) || 0) + 1
            });
          });
        }
      }), q.value = Object.values(l).map((e) => m(c({}, e), {
        options: Object.values(e.options),
        collapsed: !0
      })), t.forEach((e, a) => {
        if (e.length > 0)
          if (i.has(a))
            i.set(a, m(c({}, i.get(a) || {}), {
              variants: e
            }));
          else {
            const [f, ...y] = e;
            i.set(a, m(c({}, f), {
              variants: y
            }));
          }
      }), Array.from(i.values());
    })
  }), p = j(() => {
    var l;
    let u = s.data.value ? [...s.data.value] : [];
    if (o(h.value) || (u = u.filter((t) => t.name.toLowerCase().includes(h.value.toLowerCase()) || t.description.toLowerCase().includes(h.value.toLowerCase()))), q.value.forEach((t) => {
      const i = t.options.filter((e) => e.checked).map((e) => e.label);
      i.length > 0 && (u = u.filter(
        (e) => i.includes(e[t.key])
      ));
    }), _.value[0]) {
      const t = _.value[0], i = (l = _.value[1]) != null ? l : "asc";
      u.sort((e, a) => t === "price" ? i === "asc" ? e.price - a.price : a.price - e.price : i === "asc" ? e[t].localeCompare(a[t]) : a[t].localeCompare(e[t]));
    } else r && u.sort((t, i) => (Number(t.category_sort) || 0) - (Number(i.category_sort) || 0));
    return u;
  });
  return m(c({}, s), {
    productsSortedAndFiltered: p,
    sortBy: _,
    searchBy: h,
    options: q
  });
}
export {
  _ as a,
  h as s,
  Q as u
};
